import { css } from '@emotion/core';
import theme from "../../themes/default";
const list =
/*#__PURE__*/

/*#__PURE__*/
css("padding:", theme.spacing.medium, ";label:list;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9MaXN0L0xpc3Quc3R5bGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR2dCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9MaXN0L0xpc3Quc3R5bGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCB0aGVtZSBmcm9tICckYXVsYS90aGVtZSc7XG5cbmNvbnN0IGxpc3QgPSBjc3NgXG4gIHBhZGRpbmc6ICR7dGhlbWUuc3BhY2luZy5tZWRpdW19O1xuYDtcblxuY29uc3QgY29tcGFjdExpc3QgPSBjc3NgXG4gIHBhZGRpbmc6IDA7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIGxpc3Q6IHtcbiAgICBiYXNlOiBsaXN0LFxuICAgIGNvbXBhY3Q6IGNvbXBhY3RMaXN0LFxuICB9LFxufTtcbiJdfQ== */"), "label:list;");
const compactList =
/*#__PURE__*/
process.env.NODE_ENV === "production" ? {
  name: "1mvo6uy-compactList",
  styles: "padding:0;label:compactList;"
} : {
  name: "1mvo6uy-compactList",
  styles: "padding:0;label:compactList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9MaXN0L0xpc3Quc3R5bGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT3VCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9MaXN0L0xpc3Quc3R5bGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCB0aGVtZSBmcm9tICckYXVsYS90aGVtZSc7XG5cbmNvbnN0IGxpc3QgPSBjc3NgXG4gIHBhZGRpbmc6ICR7dGhlbWUuc3BhY2luZy5tZWRpdW19O1xuYDtcblxuY29uc3QgY29tcGFjdExpc3QgPSBjc3NgXG4gIHBhZGRpbmc6IDA7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIGxpc3Q6IHtcbiAgICBiYXNlOiBsaXN0LFxuICAgIGNvbXBhY3Q6IGNvbXBhY3RMaXN0LFxuICB9LFxufTtcbiJdfQ== */"
};
export default {
  list: {
    base: list,
    compact: compactList
  }
};